import useFilterListFacets from '@hooks/filters/use-filter-list-facets';
import { useMemo } from 'react';
import { SortByMethod, SortTypes } from '@interfaces/models/catalogFilter';
import { CategoryMenuLevels } from '@context/catalog-category-hotfilter.context';

const useCategoryFilterFacets = ({
  filterGroup,
  parentId,
  filterGroupSortBy,
}: {
  filterGroup: CategoryMenuLevels;
  parentId?: string;
  filterGroupSortBy: Partial<SortTypes> | SortByMethod;
}) => {
  const { filteredAndSortedFacets } = useFilterListFacets({ filterGroup, filterGroupSortBy });

  return useMemo(() => {
    if (!parentId) {
      return filteredAndSortedFacets;
    }
    return filteredAndSortedFacets.filter((x) => String(x.parentID) === String(parentId));
  }, [filteredAndSortedFacets, parentId]);
};

export default useCategoryFilterFacets;
